// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
// CRUD
import { HttpUtilsService } from '../../_base/crud';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';
import { environment } from '../../../../environments/environment';
import { OfficeModel } from '../../management';
// Real REST API
@Injectable({
  providedIn: 'root',
})
export class AgreementService {
  private authToken;
  private companyId;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  findByEntityContact(contactId: number, entityId: number): Observable<any> {
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const url =
      environment.AGREEMENT_BASE +
      '/companies/' +
      this.companyId +
      '/agreements/?entity_id=' +
      entityId +
      '&contact_id=' +
      contactId;

    return this.http.get<any>(url, { headers: headers });
  }

  revokeAgreement(agreementId: number): Observable<any> {
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const url =
      environment.AGREEMENT_BASE +
      '/companies/' +
      this.companyId +
      '/agreements/' +
      agreementId +
      '/revoke';

    return this.http.put<any>(url, { headers: headers });
  }

  remind(agreementId: number): Observable<any> {
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const url =
      environment.AGREEMENT_BASE +
      '/companies/' +
      this.companyId +
      '/agreements/' +
      agreementId +
      '/remind';

    return this.http.put<any>(url, { headers: headers });
  }

  resendAgreement(agreementId: number, signingProviderTemplateId: string): Observable<any> {
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const body = {
      signing_provider_template_id: signingProviderTemplateId,
    };

    const url =
      environment.AGREEMENT_BASE +
      '/companies/' +
      this.companyId +
      '/agreements/' +
      agreementId +
      '/resend';

    return this.http.put<any>(url, body, { headers: headers });
  }

  enableForOffice(office: OfficeModel, data: string): Observable<any> {
    const url =
      environment.AGREEMENT_BASE + '/companies/' + this.companyId + '/office/' + office.id;
    const body = { additional_info: data };
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);

    return this.http.post<any>(url, body, { headers: headers });
  }

  getOfficeConfig(office: OfficeModel): Observable<any> {
    const url =
      environment.AGREEMENT_BASE + '/companies/' + this.companyId + '/office/' + office.id;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);

    return this.http.get<any>(url, { headers: headers });
  }
}
